/**
 * QA overrides for in-product guidance, carried in the URL so a tester can
 * replay a surface without clearing storage or matching its audience.
 *
 * `?<param>=1` (also `true` or `all`) forces every id the page mounts;
 * `?<param>=a,b` forces only the listed ids.
 */
export function guidanceForced(param: string, id: string): boolean {
  try {
    const value = new URLSearchParams(window.location.search).get(param);
    if (!value) return false;
    return (
      value === "1" ||
      value === "true" ||
      value === "all" ||
      value.split(",").some((candidate) => candidate.trim() === id)
    );
  } catch {
    return false;
  }
}
